import React from "react";
import Header from "../Components/Header";
import SidebarAndContent from "../Components/SidebarAndContent";
import { Navigate, Route, Routes } from "react-router-dom";
import AddOrEditPartner from "../Pages/AddOrEditPartner/AddOrEditPartner";
import Partners from "../Pages/Partners/Dashboard";
import Dashboard from "../Pages/Partners/Dashboard";
import PartnersList from "../Pages/Partners/PartnersList";
import Tree from "../Pages/Partners/Tree";
import { USER_TYPES, USER_TYPES_CATEGORIES } from "../constants/globals";
import { useSelector } from "react-redux";
import RequestsList from "../Pages/Admin/RequestsList";
import RequestDetails from "../Pages/Admin/RequestDetails";
import UpdatePartnerData from "../Pages/AddOrEditPartner/UpdatePartnerData";
import RequestEMoney from "../Pages/Partners/RequestEMoney";
import AddNewCourse from "../Pages/Partners/AddNewCourse";
import AdminPartnersList from "../Pages/Admin/AdminPartnersList";
import Profile from "../Pages/Admin/Profile";
import UpdatePartnerProfile from "../Pages/Admin/UpdatePartnerProfile";
import PaymentDetails from "../Pages/Admin/PaymentDetails";
import Mycourses from "../Pages/Partners/courses/Mycourses";
import SingleCourse from "../Pages/Partners/courses/SingleCourse";
import CourseSingleLesson from "../Pages/Partners/courses/CourseSingleLesson";
import TransferEMoney from "../Pages/Partners/TransferEMoney";
import ReportDetails from "../Pages/Admin/ReportDetails";
import Reports from "../Pages/Admin/Reports/Reports";
import SettlementList from "../Pages/Admin/settlements/SettlementList";
import NewSettlement from "../Pages/Admin/settlements/NewSettlement";
import SettlementPartnerList from "../Pages/Admin/settlements/SettlementPartnerList";
import UnsettledPartner from "../Pages/Admin/settlements/UnsettledPartner";
import SettledPartner from "../Pages/Admin/settlements/SettledPartner";
import DirectPvHistory from "../Pages/Admin/settlements/DirectPvHistory";
import EndSettlement from "../Pages/Admin/settlements/EndSettlement";
import ReplaceEmoneyList from "../Pages/Admin/replaceEmoney/ReplaceEmoneyList";
import SettlementHistory from "../Pages/Admin/settlements/SettlementHistory";
import ReplaceEmoney from "../Pages/Partners/ReplaceEmoney";
import ReplaceEmoneyDetails from "../Pages/Admin/replaceEmoney/ReplaceEmoneyDetails";
import AnnouncementsList from "../Pages/Admin/announcements/AnnouncementsList";
import NewAnnouncement from "../Pages/Admin/announcements/NewAnnouncement";
import AnnouncementDetails from "../Pages/Admin/announcements/AnnouncementDetails";
import AnnouncementEdit from "../Pages/Admin/announcements/AnnouncementEdit";
import WalletManagement from "../Pages/Admin/WalletManagement";
import AccountsReviews from "../Pages/Admin/AccountsReviews";
import AccountReviewDetails from "../Pages/Admin/AccountReviewDetails";
import Transactions from "../Pages/Shared/Transactions";
import TransactionDetails from "../Pages/Shared/TransactionDetails";
import Footer from "../Components/Footer";
import PackageManagement from "../Pages/Admin/PackageManagement";
import ListPackageManagementDetails from "../Pages/Admin/ListPackageManagementDetails";
import PackageDetails from "../Pages/Admin/PackageDetails";
import PartnersListInPackage from "../Pages/Admin/PartnersListInPackage";
import AddNewPackage from "../Pages/Admin/AddNewPackage/AddNewPackage";
import UpdatePackage from "../Pages/Admin/PackageModule/UpdatePackage";
import ListInstructors from "../Pages/Admin/InstructorsModule/ListInstructors";
import AddNewInstructor from "../Pages/Admin/InstructorsModule/AddNewInstructor";
import InstructorDetails from "../Pages/Admin/InstructorsModule/InstructorDetails";
import ListCoursesManagement from "../Pages/Admin/CoursesModule/ListCoursesManagement";
import CourseDetails from "../Pages/Admin/CoursesModule/CourseDetails";
import AddNewLesson from "../Pages/Admin/CoursesModule/AddNewLesson";
import CreateNewCourse from "../Pages/Admin/CoursesModule/CreateNewCourse";
import EditLessonInCourse from "../Pages/Admin/CoursesModule/EditLessonInCourse";
import LessonDetails from "../Pages/Admin/CoursesModule/LessonDetails";
import UpdateCourse from "../Pages/Admin/CoursesModule/UpdateCourse";
import UpdateInstructorData from "../Pages/Admin/InstructorsModule/UpdateInstructorData";
import MyProfile from "../Pages/Partners/MyProfile";
import PartnerNetwork from "../Pages/Admin/PartnerNetwork";
import PrivacyPolicy from "../Pages/Partners/PrivacyPolicy";
import TermsOfUse from "../Pages/Partners/TermsOfUse";
import PartnerTransactionsHistory from "../Pages/Admin/PartnerTransactionsHistory/PartnerTransactionsHistory";
import PartnerSettlementHistory from "../Pages/PartnerSettlementHistory/PartnerSettlementHistory";
import ViewCourse from "../Pages/Partners/ViewCourse/ViewCourse";
import RenewSubscriptionForm from "../Pages/Partners/RenewSubscriptionForm/RenewSubscriptionForm";
import SubscriptionRenewalList from "../Pages/Admin/SubscriptionRenewalList/SubscriptionRenewalList";
import RenewSubscriptionFormForAdmin from "../Pages/Admin/RenewSubscriptionFormForAdmin/RenewSubscriptionFormForAdmin";
import RenewSubscriptionReport from "../Pages/Admin/Reports/RenewSubscriptionReport/RenewSubscriptionReport";
import WalletsReport from "../Pages/Admin/Reports/WalletsReport/WalletsReport";
import DeactivateHistoryReport from "../Pages/Admin/Reports/DeactivateHistoryReport/DeactivateHistoryReport";
import PVsTransactionsReport from "../Pages/Admin/Reports/PVsTransactionsReport/PVsTransactionsReport";
import DirectEmoneyReport from "../Pages/Admin/Reports/DirectEmoneyReport/DirectEmoneyReport";
import ExpiredSubscriptionReport from "../Pages/Admin/Reports/ExpiredSubscriptionReport/ExpiredSubscriptionReport";
import MessagesList from "../Pages/Partners/MessagesList/MessagesList";
import MessageDetails from "../Pages/Partners/MessageDetails/MessageDetails";
import SendNewMessage from "../Pages/Partners/SendNewMessage/SendNewMessage";
import AdminMessages from "../Pages/Admin/AdminMessages/AdminMessages";
import PartnersListToSendNewMessage from "../Pages/Admin/PartnersListToSendNewMessage/PartnersListToSendNewMessage";
import SendNewMessageToPartner from "../Pages/Admin/SendNewMessageToPartner/SendNewMessageToPartner";
import VouchersList from "../Pages/Partners/VouchersList/VouchersList";
import MyVouchers from "../Pages/Partners/MyVouchers/MyVouchers";
const AuthenticatedRoutes = () => {
  const { loggedInUser } = useSelector((state) => state?.Auth);
  const currentUserType = loggedInUser?.data?.model?.user_type_id;
  const currentClientCategory =
    loggedInUser?.data?.model?.client?.client_category_id;

  return (
    <div className="layout-fluid" dir="ltr">
      <div className="mdk-header-layout js-mdk-header-layout tw-size-full">
        <Header />
        <div className="tw-min-h-[100vh]">
          <Routes>
            <Route path="/" element={<SidebarAndContent />}>
              {currentUserType === USER_TYPES.ADMIN && (
                <>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/requests" element={<RequestsList />} />
                  <Route
                    path="/request-details/:id"
                    element={<RequestDetails />}
                  />
                  <Route
                    path="/partners-list"
                    element={<AdminPartnersList />}
                  />
                  <Route
                    path="/partners-list/partner-network/:id"
                    element={<PartnerNetwork />}
                  />

                  <Route path="/tree/:id?" element={<Tree />} />
                  <Route path="/profile/:id" element={<Profile />} />
                  <Route
                    path="/update-profile/:id"
                    element={<UpdatePartnerProfile />}
                  />
                  <Route
                    path="/payment-details/:id"
                    element={<PaymentDetails />}
                  />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/reports/:id" element={<ReportDetails />} />
                  {/* Settlements */}
                  <Route path="/settlements" element={<SettlementList />} />
                  <Route path="/new-settlement" element={<NewSettlement />} />
                  <Route
                    path="/settlement/:id/partner-list"
                    element={<SettlementPartnerList />}
                  />
                  <Route
                    path="/settlement/:id/unsettled-partners/:partnerId"
                    element={<UnsettledPartner />}
                  />
                  <Route
                    path="/settlement/:id/settled-partners/:partnerId"
                    element={<SettledPartner />}
                  />
                  <Route
                    path="/settlement/direct-pv-history/:id/:partnerId"
                    element={<DirectPvHistory />}
                  />
                  <Route
                    path="/partner-settlement-history/:partnerId"
                    element={<PartnerSettlementHistory />}
                  />
                  <Route
                    path="/end-settlement/:id/"
                    element={<EndSettlement />}
                  />
                  <Route
                    path="/replace-emoney"
                    element={<ReplaceEmoneyList />}
                  />
                  <Route
                    path="/replace-emoney-details/:id"
                    element={<ReplaceEmoneyDetails />}
                  />

                  <Route
                    path="/settlement-history/:id/"
                    element={<SettlementHistory />}
                  />
                  {/* Accounts Setting */}
                  <Route
                    path="/accounts-review"
                    element={<AccountsReviews />}
                  />
                  <Route
                    path="/accounts-review/:clientId"
                    element={<AccountReviewDetails />}
                  />
                  {/* Transactions */}
                  <Route path="/transactions" element={<Transactions />} />
                  <Route
                    path="/transactions/:transactionId"
                    element={<TransactionDetails />}
                  />
                  <Route
                    path="/PartnerTransactionsHistory/:id"
                    element={<PartnerTransactionsHistory />}
                  />

                  {/* Packages */}
                  <Route
                    path="/package-management"
                    element={<PackageManagement />}
                  />
                  <Route
                    path="/package-management/:packageManagementId"
                    element={<ListPackageManagementDetails />}
                  />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId"
                    element={<PackageDetails />}
                  />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId/partners-list-in-package"
                    element={<PartnersListInPackage />}
                  />
                  <Route path="/add-new-package" element={<AddNewPackage />} />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId/update-package"
                    element={<UpdatePackage />}
                  />

                  {/* Instructors Management */}
                  <Route
                    path="/instructors-management"
                    element={<ListInstructors />}
                  />
                  <Route
                    path="/add-new-instructor"
                    element={<AddNewInstructor />}
                  />
                  <Route
                    path="/edit-instructor-data/:instructorId"
                    element={<UpdateInstructorData />}
                  />
                  <Route
                    path="/instructor-details/:instructorId"
                    element={<InstructorDetails />}
                  />

                  {/* Courses Management */}
                  <Route
                    path="/courses-management"
                    element={<ListCoursesManagement />}
                  />
                  <Route path="/create-course" element={<CreateNewCourse />} />
                  <Route
                    path="/update-course/:courseId"
                    element={<UpdateCourse />}
                  />
                  <Route
                    path="/courses-management/:courseId"
                    element={<CourseDetails />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course"
                    element={<LessonDetails />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course/add-new-lesson"
                    element={<AddNewLesson />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course/edit-lesson/:lessonId"
                    element={<EditLessonInCourse />}
                  />

                  {/* Announcements */}
                  <Route
                    path="/announcements"
                    element={<AnnouncementsList />}
                  />
                  <Route
                    path="/announcements/create"
                    element={<NewAnnouncement />}
                  />
                  <Route
                    path="/announcements/:id"
                    element={<AnnouncementDetails />}
                  />
                  <Route
                    path="/announcements/edit/:id"
                    element={<AnnouncementEdit />}
                  />
                  <Route
                    path="/wallet-management"
                    element={<WalletManagement />}
                  />

                  <Route
                    path="/renew-subscription"
                    element={<SubscriptionRenewalList />}
                  />
                  <Route
                    path="/renew-subscription-report"
                    element={<RenewSubscriptionReport />}
                  />
                  <Route
                    path="/renew-client-subscription/:clientId"
                    element={<RenewSubscriptionFormForAdmin />}
                  />
                  <Route path="/wallets-report" element={<WalletsReport />} />
                  <Route
                    path="/deactivate-history-report"
                    element={<DeactivateHistoryReport />}
                  />
                  <Route
                    path="/PV-transactions-report"
                    element={<PVsTransactionsReport />}
                  />
                  <Route
                    path="/direct-e-money-report"
                    element={<DirectEmoneyReport />}
                  />
                  <Route
                    path="/expired-subscription-report"
                    element={<ExpiredSubscriptionReport />}
                  />
                  {/* Messages */}
                  <Route path="/admin-messages" element={<AdminMessages />} />
                  <Route
                    path="/partners-list-to-send-messages"
                    element={<PartnersListToSendNewMessage />}
                  />
                  <Route
                    path="/send-new-message-to-partner/:partnerId"
                    element={<SendNewMessageToPartner />}
                  />
                </>
              )}

              {currentUserType === USER_TYPES.MODERATOR && (
                <>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/requests" element={<RequestsList />} />
                  <Route
                    path="/request-details/:id"
                    element={<RequestDetails />}
                  />
                  <Route
                    path="/partners-list"
                    element={<AdminPartnersList />}
                  />
                  <Route
                    path="/partners-list/partner-network/:id"
                    element={<PartnerNetwork />}
                  />

                  <Route path="/tree/:id?" element={<Tree />} />
                  <Route path="/profile/:id" element={<Profile />} />
                  <Route
                    path="/update-profile/:id"
                    element={<UpdatePartnerProfile />}
                  />
                  <Route
                    path="/payment-details/:id"
                    element={<PaymentDetails />}
                  />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/reports/:id" element={<ReportDetails />} />
                  {/* Settlements */}
                  <Route path="/settlements" element={<SettlementList />} />
                  <Route path="/new-settlement" element={<NewSettlement />} />
                  <Route
                    path="/settlement/:id/partner-list"
                    element={<SettlementPartnerList />}
                  />
                  <Route
                    path="/settlement/:id/unsettled-partners/:partnerId"
                    element={<UnsettledPartner />}
                  />
                  <Route
                    path="/settlement/:id/settled-partners/:partnerId"
                    element={<SettledPartner />}
                  />
                  <Route
                    path="/settlement/direct-pv-history/:id/:partnerId"
                    element={<DirectPvHistory />}
                  />
                  <Route
                    path="/end-settlement/:id/"
                    element={<EndSettlement />}
                  />

                  <Route
                    path="/settlement-history/:id/"
                    element={<SettlementHistory />}
                  />
                  {/* Accounts Setting */}
                  <Route
                    path="/accounts-review"
                    element={<AccountsReviews />}
                  />
                  <Route
                    path="/accounts-review/:clientId"
                    element={<AccountReviewDetails />}
                  />
                  {/* Transactions */}
                  <Route path="/transactions" element={<Transactions />} />
                  <Route
                    path="/transactions/:transactionId"
                    element={<TransactionDetails />}
                  />

                  {/* Packages */}
                  <Route
                    path="/package-management"
                    element={<PackageManagement />}
                  />
                  <Route
                    path="/package-management/:packageManagementId"
                    element={<ListPackageManagementDetails />}
                  />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId"
                    element={<PackageDetails />}
                  />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId/partners-list-in-package"
                    element={<PartnersListInPackage />}
                  />
                  <Route path="/add-new-package" element={<AddNewPackage />} />
                  <Route
                    path="/package-management/:packageManagementId/package-details/:packageId/update-package"
                    element={<UpdatePackage />}
                  />

                  {/* Instructors Management */}
                  <Route
                    path="/instructors-management"
                    element={<ListInstructors />}
                  />
                  <Route
                    path="/add-new-instructor"
                    element={<AddNewInstructor />}
                  />
                  <Route
                    path="/edit-instructor-data/:instructorId"
                    element={<UpdateInstructorData />}
                  />
                  <Route
                    path="/instructor-details/:instructorId"
                    element={<InstructorDetails />}
                  />

                  {/* Courses Management */}
                  <Route
                    path="/courses-management"
                    element={<ListCoursesManagement />}
                  />
                  <Route path="/create-course" element={<CreateNewCourse />} />
                  <Route
                    path="/update-course/:courseId"
                    element={<UpdateCourse />}
                  />
                  <Route
                    path="/courses-management/:courseId"
                    element={<CourseDetails />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course"
                    element={<LessonDetails />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course/add-new-lesson"
                    element={<AddNewLesson />}
                  />
                  <Route
                    path="/courses-management/:courseId/lessons-in-course/edit-lesson/:lessonId"
                    element={<EditLessonInCourse />}
                  />

                  {/* Announcements */}
                  <Route
                    path="/announcements"
                    element={<AnnouncementsList />}
                  />
                  <Route
                    path="/announcements/create"
                    element={<NewAnnouncement />}
                  />
                  <Route
                    path="/announcements/:id"
                    element={<AnnouncementDetails />}
                  />
                  <Route
                    path="/announcements/edit/:id"
                    element={<AnnouncementEdit />}
                  />
                  <Route
                    path="/renew-subscription"
                    element={<SubscriptionRenewalList />}
                  />
                  <Route
                    path="/renew-subscription-report"
                    element={<RenewSubscriptionReport />}
                  />
                  <Route
                    path="/renew-client-subscription/:clientId"
                    element={<RenewSubscriptionFormForAdmin />}
                  />
                  <Route path="/wallets-report" element={<WalletsReport />} />
                  <Route
                    path="/deactivate-history-report"
                    element={<DeactivateHistoryReport />}
                  />
                  <Route
                    path="/PV-transactions-report"
                    element={<PVsTransactionsReport />}
                  />
                  <Route
                    path="/direct-e-money-report"
                    element={<DirectEmoneyReport />}
                  />
                  <Route
                    path="/expired-subscription-report"
                    element={<ExpiredSubscriptionReport />}
                  />
                  {/* Messages */}
                  <Route path="/admin-messages" element={<AdminMessages />} />
                  <Route
                    path="/partners-list-to-send-messages"
                    element={<PartnersListToSendNewMessage />}
                  />
                  <Route
                    path="/send-new-message-to-partner/:partnerId"
                    element={<SendNewMessageToPartner />}
                  />
                </>
              )}

              {currentUserType === USER_TYPES.PARTNER &&
                currentClientCategory ===
                  USER_TYPES_CATEGORIES.SERVICE_MARKETING && (
                  <>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/partners-list" element={<PartnersList />} />
                    <Route path="/tree/:id?" element={<Tree />} />
                    <Route
                      path="/partners/:type"
                      element={<AddOrEditPartner />}
                    />
                    <Route
                      path="/partners/:type/:userId"
                      element={<AddOrEditPartner />}
                    />
                    <Route
                      path="/partners/update/:userId"
                      element={<UpdatePartnerData />}
                    />
                    <Route
                      path="/partners/request-e-money/"
                      element={<RequestEMoney />}
                    />
                    <Route
                      path="/partners/transfer-e-money/"
                      element={<TransferEMoney />}
                    />
                    <Route
                      path="/partners/replace-e-money"
                      element={<ReplaceEmoney />}
                    />
                    <Route
                      path="/partners/add-new-course/"
                      element={<AddNewCourse />}
                    />
                    <Route
                      path="/partners/my-courses"
                      element={<Mycourses />}
                    />
                    <Route
                      path="/partners/courses/:id"
                      element={<SingleCourse />}
                    />
                    <Route
                      path="/partners/view-course/:id"
                      element={<ViewCourse />}
                    />
                    <Route
                      path="/partners/courses/:id/:lessonId"
                      element={<CourseSingleLesson />}
                    />
                    <Route path="/myPrfoile" element={<MyProfile />} />

                    {/* Transactions */}
                    <Route path="/transactions" element={<Transactions />} />
                    <Route
                      path="/transactions/:transactionId"
                      element={<TransactionDetails />}
                    />

                    {/* policy */}
                    <Route path="privacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="termsOfUse" element={<TermsOfUse />} />

                    {/* RenewSubscriptionForm */}
                    <Route
                      path="/renew-subscription"
                      element={<RenewSubscriptionForm />}
                    />
                    {/* CLient Messages */}
                    <Route path="/messages" element={<MessagesList />} />
                    <Route
                      path="/messages/:messageId"
                      element={<MessageDetails />}
                    />
                    <Route
                      path="/send-new-message"
                      element={<SendNewMessage />}
                    />
                    <Route path="/vouchers-list" element={<VouchersList />} />
                    <Route path="/my-vouchers-list" element={<MyVouchers />} />

                    <Route path="*" element={<Navigate to="/" />} />
                  </>
                )}
              {currentUserType === USER_TYPES.PARTNER &&
                (currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_ONLY ||
                  currentClientCategory === USER_TYPES_CATEGORIES.NEWCOMER) && (
                  <>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/myPrfoile" element={<MyProfile />} />
                    <Route
                      path="/partners/my-courses"
                      element={<Mycourses />}
                    />
                    <Route
                      path="/partners/courses/:id"
                      element={<SingleCourse />}
                    />
                    <Route
                      path="/renew-subscription"
                      element={<RenewSubscriptionForm />}
                    />
                    <Route
                      path="/partners/courses/:id/:lessonId"
                      element={<CourseSingleLesson />}
                    />
                    <Route path="/messages" element={<MessagesList />} />
                    <Route
                      path="/messages/:messageId"
                      element={<MessageDetails />}
                    />
                    <Route
                      path="/send-new-message"
                      element={<SendNewMessage />}
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                  </>
                )}
              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AuthenticatedRoutes;
